// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: var(--bg-dark);
  color: white;
  padding: 64px 0 32px;
  margin-top: auto;
}

.footer__content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 48px;
}

.footer__section {
  display: flex;
  flex-direction: column;
}

.footer__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
}

.footer__logo .logo-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border-radius: 10px;
  font-weight: 700;
}

.footer__logo .logo-text {
  color: white;
}

.footer__description {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  font-size: 14px;
}

.footer__title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: white;
}

.footer__links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer__links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footer__links a:hover {
  color: white;
}

.footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer__copyright {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer__social {
  display: flex;
  gap: 16px;
}

.footer__social a {
  font-size: 20px;
  text-decoration: none;
  transition: transform 0.2s;
}

.footer__social a:hover {
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .footer__content {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer__bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\r\n  background: var(--bg-dark);\r\n  color: white;\r\n  padding: 64px 0 32px;\r\n  margin-top: auto;\r\n}\r\n\r\n.footer__content {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr 1fr;\r\n  gap: 48px;\r\n  margin-bottom: 48px;\r\n}\r\n\r\n.footer__section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.footer__logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.footer__logo .logo-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  color: white;\r\n  border-radius: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\n.footer__logo .logo-text {\r\n  color: white;\r\n}\r\n\r\n.footer__description {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  line-height: 1.6;\r\n  font-size: 14px;\r\n}\r\n\r\n.footer__title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n  color: white;\r\n}\r\n\r\n.footer__links {\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.footer__links a {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  text-decoration: none;\r\n  font-size: 14px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.footer__links a:hover {\r\n  color: white;\r\n}\r\n\r\n.footer__bottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 32px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.footer__copyright {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 14px;\r\n}\r\n\r\n.footer__social {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n.footer__social a {\r\n  font-size: 20px;\r\n  text-decoration: none;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.footer__social a:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .footer__content {\r\n    grid-template-columns: 1fr;\r\n    gap: 32px;\r\n  }\r\n\r\n  .footer__bottom {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
